
import React, { createContext, useContext, useState, useRef } from 'react';

interface LoadingContextType {
    showLoading: () => void;
    hideLoading: () => void;
    isLoading: boolean;
}

const LoadingContext = createContext<LoadingContextType>({
    isLoading: false,
    showLoading: () => {},
    hideLoading: () => {},
});

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const showLoading = () => {
   
        timeoutRef.current = setTimeout(() => {
            setIsLoading(true);
        }, 200);
    };

    const hideLoading = () => {
        // 타이머가 남아 있으면 실행되지 않게 막음
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsLoading(false);
    };

    return (
        <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);
